export default "__VITE_ASSET__CUXucT3t__"